import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ListItem.module.css';
import CustomButtom from '../../../../../components/buttons/CustomButton';
import { DataProviderInstance } from "../../../../../api/DataProvider";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Chip, Typography } from '@mui/material';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ColorPalette from '../../../../../colorpalette/ColorPalette';

const ListItem = ({ id, date, title, description, onSelect }) => {

    const formatDate = (dateString) => {
       
        const [year, month, day] = dateString.split('-');

        return `${day}/${month}/${year}`;
    };

    const formatTime = (dateString) => {
        const date = new Date(dateString);
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const handleViewDetails = () => {
        onSelect(id);
    }
    
    // Function to get the first 2 lines of text
    const getFirstTwoLines = (text) => {
        if (!text) return '';
        
        // Split by newline and get first two lines
        const lines = text.split('\n');
        const firstTwoLines = lines.slice(0, 2).join('\n');
        
        // If there are more than 2 lines, add ellipsis
        return lines.length > 2 ? `${firstTwoLines}...` : firstTwoLines;
    };

    return (
        <div className={styles.container}>
            <div className={styles.infos}>
                <Chip
                    icon={<CalendarMonthOutlinedIcon fontSize="small" />}
                    label={formatDate(date)}
                    variant="outlined"
                    sx={{
                        backgroundColor: 'transparent',
                        color: ColorPalette.textDark,
                        borderColor: ColorPalette.border,
                        '&:hover': {
                            backgroundColor: ColorPalette.blueAlpha2,
                        },
                        fontWeight: 500,
                        borderRadius: '8px',
                        padding: '2px 4px',
                        height: '28px',
                        fontSize: '13px',
                        '& .MuiChip-icon': {
                            color: ColorPalette.blueMain,
                            marginLeft: '4px',
                            marginRight: '8px',
                            fontSize: '16px'
                        },
                        '& .MuiChip-label': {
                            padding: '0 6px'
                        }
                    }}
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: ColorPalette.textDark }}>
                        {title}
                    </Typography>
                    {description && (
                        <Typography
                            variant="body2"
                            sx={{
                                color: ColorPalette.textMedium,
                                fontSize: '13px',
                                maxWidth: '400px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical'
                            }}
                        >
                            {getFirstTwoLines(description)}
                        </Typography>
                    )}
                </Box>
            </div>
            <div style={{ flexShrink: 0 }}> {/* Wrapper to prevent button from shrinking */}
                <CustomButtom
                    style="secondary"
                    variant="outlined"
                    icon={<InfoOutlinedIcon fontSize="small" />}
                    onClick={handleViewDetails}
                    rounded={true}
                />
            </div>
        </div>
    );
};

export default ListItem;